// extracted by mini-css-extract-plugin
export default {"next_order":"ZB","recurringdis":"aC","reactivate_button":"bC","order__summary_title":"cC","order__summary_items":"eC","order__summary_item":"fC","order__summary_item_title":"gC","order__summary_item_quantity":"hC","order__item_separator":"iC","discount":"jC","promowrapper":"kC"};
    if(module.hot) {
      // 1714442369319
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  